module.exports = __webpack_public_path__ + "15_pvis.pdf?6438f95757feca046389ea54217214ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_pvis.pdf
// module id = 144
// module chunks = 0